import { render, staticRenderFns } from "./login_page.vue?vue&type=template&id=afb65280"
import script from "./login_page.vue?vue&type=script&lang=js"
export * from "./login_page.vue?vue&type=script&lang=js"
import style0 from "./login_page.vue?vue&type=style&index=0&id=afb65280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports